import { DirectoriesPage } from "./DirectoriesPage";
export default DirectoriesPage;
